import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const HeaderTwo = () => {
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    var offCanvasNav = document.getElementById("offcanvas-navigation");
    var offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu");

    for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
      offCanvasNavSubMenu[i].insertAdjacentHTML(
        "beforebegin",
        "<span class='mean-expand-class'>+</span>"
      );
    }

    var menuExpand = offCanvasNav.querySelectorAll(".mean-expand-class");
    var numMenuExpand = menuExpand.length;

    function sideMenuExpand() {
      if (this.parentElement.classList.contains("active") === true) {
        this.parentElement.classList.remove("active");
      } else {
        for (let i = 0; i < numMenuExpand; i++) {
          menuExpand[i].parentElement.classList.remove("active");
        }
        this.parentElement.classList.add("active");
      }
    }

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", sideMenuExpand);
    }
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
  }, []);

  const mobileMenu = () => {
    setActive(!active);
  };
  return (
    <header className="nav-header header-layout2">
      <div className="header-top">
        <div className="container">
          <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
            <div className="col-auto d-none d-lg-block">
              <div className="header-logo">
                <Link to="/">
                  <img src="assets/img/Logo.png" alt="Silverline" width={180} />
                </Link>
              </div>
            </div>
            <div className="col-auto">
              <div className="header-grid-info">
                <ul>
                  <li>
                    <div className="icon">
                      <i className="fas fa-phone" />
                    </div>
                    <div className="header-grid-info-details text-white">
                      <p className="fw-bold">Call Us</p>
                      <h6> 07496360002</h6>
                      <h6> 02476347151</h6>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div className="header-grid-info-details">
                      <p className="fw-bold">
                        UNIT 2 POOL ROAD INDUSTRIAL ESTATE
                      </p>
                      <h6>NUNEATON, CV10 9AE, United Kingdom </h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`sticky-wrapper ${scroll && "sticky"}`}>
        {/* Main Menu Area */}
        <div className="menu-area">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto header-navbar-logo">
                <div className="header-logo">
                  <Link to="/">
                    <img
                      src="assets/img/Logo.png"
                      alt="Silverline"
                      width={130}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-auto">
                <nav className="main-menu d-none d-lg-inline-block">
                  <ul>
                    {[
                      { path: "/", label: "Home" },
                      { path: "/showroom", label: "Showroom" },
                      { path: "/part-exchange", label: "Part Exchange" },
                      { path: "/sell-car", label: "Sell Your Car" },
                      { path: "/all-services", label: "Car Repair/MOT" },
                    ].map(({ path, label }) => (
                      <li key={label}>
                        {path ? (
                          <NavLink
                            to={path}
                            className={({ isActive }) =>
                              `nav-link ${
                                isActive
                                  ? "nav-link-active fw-bold"
                                  : "text-dark fw-bold"
                              }`
                            }
                          >
                            {label}
                          </NavLink>
                        ) : (
                          <span className="nav-link text-dark cursor-pointer">
                            {label}
                          </span>
                        )}
                      </li>
                    ))}
                    <li className="menu-item-has-children">
                      <NavLink to="#" className="nav-link text-dark">
                        Others
                      </NavLink>
                      <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/about"
                            className={(navData) =>
                              navData.isActive ? "active" : ""
                            }
                          >
                            About Us
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/contact"
                            className={(navData) =>
                              navData.isActive ? "active" : ""
                            }
                          >
                            Contact Us
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
                <div className="navbar-right d-inline-flex d-lg-none">
                  <button
                    type="button"
                    className="menu-toggle icon-btn"
                    onClick={mobileMenu}
                  >
                    <i className="fas fa-bars" />
                  </button>
                </div>
              </div>
              <div className="col-auto d-xl-block d-none">
                <div className="social-links">
                  <Link to="https://www.facebook.com/profile.php?id=61573496728160">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="https://www.instagram.com/silverlineautos">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="https://www.tiktok.com/@silverlineauto">
                    <i className="fab fa-tiktok" />
                  </Link>
                  <Link to="https://www.youtube.com/channel/UCQunKZ43Cqsexnm3W9zJJvw">
                    <i className="fab fa-youtube" />
                  </Link>
                  <Link to="https://g.co/kgs/3gsftyf">
                    <i className="fab fa-google" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu-wrapper  ${active && "body-visible"}`}>
          <div className="mobile-menu-area">
            <div className="mobile-logo">
              <Link to="/">
                <img src="assets/img/Logo.png" alt="Fixturbo" />
              </Link>
              <button className="menu-toggle" onClick={mobileMenu}>
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="mobile-menu">
              <ul id="offcanvas-navigation">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <NavLink
                    to="/showroom"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Showroom
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/part-exchange"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Part exchange
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/sell-car"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Sell Your Car
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/all-services"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Our Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    About
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/contact"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Contact
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderTwo;
